module.exports = "<li class=\"sol-threshold-search-control\" *ngIf=\"showSearchControl$ | async\">\n    <span class=\"ico icon-search svg\" (click)=\"toggleSearchBar()\"></span>\n</li>"


//////////////////
// WEBPACK FOOTER
// ./src/app/threshold/components/search/search-control.component.html
// module id = ./src/app/threshold/components/search/search-control.component.html
// module chunks = 0